import React from "react";
import useTranslations from "../hooks/useTranslations";
import { Switch, Route } from "react-router-dom";

import {
  Container,
  ScreenContainer,
  ScreenHeader,
  Button,
  Link,
} from "../components/wombat-ui";
import { EditIcon } from "../components/icons";

import ViewerForm from "../components/viewer/ViewerForm";
import UpdatePasswordModalForm from "../components/viewer/UpdatePasswordModalForm";

import useViewer from "../hooks/useViewer";

const ViewerProfileScreen = () => {
  const t = useTranslations();
  const viewer = useViewer();

  return (
    <ScreenContainer>
      <ScreenHeader
        title={t("userProfile.title") as string}
        description={t("userProfile.description") as string}
        icon={EditIcon}
        actions={[
          <Link
            to="/profile/update-password"
            key="updatePassword"
            variant="button-subtle"
          >
            {t("userProfile.updatePassword")}
          </Link>,
          <Button key="update" type="submit" form="userForm">
            {t("forms.actions.send")}
          </Button>,
        ]}
      />
      <Container>
        <Switch>
          <Route
            path="/"
            render={() => (
              <ViewerForm
                defaultValues={{
                  email: viewer.email,
                  name: viewer.name,
                  locale: viewer.locale,
                  avatar: {
                    filename: "",
                    data: viewer.avatar || "",
                  },
                }}
              />
            )}
          />
        </Switch>
      </Container>
      <Route
        path="/profile/update-password"
        exact
        component={UpdatePasswordModalForm}
      />
    </ScreenContainer>
  );
};

export default ViewerProfileScreen;
